import { useEffect, useMemo, useState } from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { usePayrollResults } from 'modules/payroll_bundle/lib/PayrollResultContext'
import { UPDATE_DATA } from 'modules/payroll_bundle/lib/constants'

const EmptyState = () => {
  const [src, setSrc] = useState<string>('')
  const {
    access: { locale: userLocale },
  } = useCurrentSession()
  const { resultDispatch } = usePayrollResults()

  const getImageSrc = (locale: string) =>
    `/assets/images/payroll/results-empty-state-v2/${locale}.png`
  const defaultSrc = getImageSrc('en')
  const imageSrc = useMemo(() => getImageSrc(userLocale), [userLocale])

  useEffect(() => {
    setSrc(imageSrc)
  }, [imageSrc])

  const onError = () => setSrc(defaultSrc)

  const onClick = () => {
    resultDispatch({
      type: UPDATE_DATA,
      payload: { showUploadModal: true },
    })
    track(trackingEvents.payroll.importResult)
  }

  const title = i18n.t('payroll_bundle.payroll_results.results.empty_state.title')

  return (
    <Box width="full" alignItems="center" gap="s64" paddingTop="s48">
      <Box alignItems="center" textAlign="center" width="s400" gap="s16">
        <Text size="300" weight="semibold" color="grey1000">
          {title}
        </Text>
        <Text size="200" weight="normal" color="grey800">
          {i18n.t('payroll_bundle.payroll_results.results.empty_state.description')}
        </Text>
        <Button type="primary" onClick={onClick}>
          {i18n.t('payroll_bundle.payroll_results.results.empty_state.submit')}
        </Button>
      </Box>
      <Box height="fit-content" alignItems="center" justifyContent="center" flexGrow>
        <img src={src} width="100%" onError={onError} alt={title} />
      </Box>
    </Box>
  )
}

export default EmptyState
